import ModalBody from "./modal-body";

export default ModalBody;